declare global {
    interface Window {
        _uxa: Array<unknown[]>
    }
}

export default defineNuxtPlugin(() => {
    const { isAuthenticated, user, currentRoutePath } = useAuth()

    function loadScript() {
        if (document.querySelector('script[src*="contentsquare.net"]')) return
        window._uxa = window._uxa || []
        const script = document.createElement('script')
        script.src = 'https://t.contentsquare.net/uxa/fd045b679dc29.js'
        script.async = true
        document.head.appendChild(script)
    }

    function identifyUser() {
        if (!user.value) return
        window._uxa = window._uxa || []
        // Scope 1 = visit-level variable (зберігається протягом всієї сесії)
        window._uxa.push(['setCustomVariable', 1, 'userId', String(user.value.publicHash), 1])
        window._uxa.push(['setCustomVariable', 2, 'role', user.value.role, 1])
    }

    // Завантажуємо скрипт і ідентифікуємо лише авторизованих користувачів
    watch(isAuthenticated, (authenticated) => {
        if (!authenticated) return
        loadScript()
        identifyUser()
    }, { immediate: true })

    // SPA virtual pageview при кожній зміні маршруту
    watch(currentRoutePath, (path) => {
        if (!isAuthenticated.value) return
        window._uxa = window._uxa || []
        window._uxa.push(['trackPageview', path])
    })
})